(function () {
  function setupRow(row) {
    var track = row.querySelector('[data-rmg-track]');
    var group = row.querySelector('[data-rmg-group]');
    if (!track || !group) return;

    // Reset any previous clones (theme editor re-render)
    track.querySelectorAll('[data-rmg-clone]').forEach(function (node) {
      node.remove();
    });
    track.classList.remove('is-ready');
    track.style.animationDuration = '';
    track.style.removeProperty('--rmg-loop');

    // Need the original group laid out before measuring
    var groupWidth = group.offsetWidth;
    if (!groupWidth) return;

    // Duplicate groups until track is wide enough for a seamless one-group loop
    var safety = 0;
    while (track.scrollWidth < Math.max(row.offsetWidth * 2, groupWidth * 2) + 40 && safety < 12) {
      var clone = group.cloneNode(true);
      clone.setAttribute('data-rmg-clone', 'true');
      clone.setAttribute('aria-hidden', 'true');
      clone.querySelectorAll('[data-rmg-open]').forEach(function (btn) {
        btn.removeAttribute('data-shopify-editor-block');
      });
      track.appendChild(clone);
      safety += 1;
    }

    // Ensure at least one clone so loop distance always has a matching twin
    if (track.children.length < 2) {
      var fallback = group.cloneNode(true);
      fallback.setAttribute('data-rmg-clone', 'true');
      fallback.setAttribute('aria-hidden', 'true');
      track.appendChild(fallback);
    }

    // Animate by exact first-group width (not -50% of total) so the loop never jumps/reverses
    track.style.setProperty('--rmg-loop', group.offsetWidth + 'px');

    var speed = parseFloat(row.getAttribute('data-rmg-speed') || '40', 10);
    if (!speed || speed < 10) speed = 40;
    // Keep perceived speed consistent as content width changes
    var duration = Math.max(18, (group.offsetWidth / 80) * (speed / 40));
    track.style.animationDuration = duration + 's';
    track.classList.add('is-ready');

    if (row.dataset.rmgPauseBound !== 'true') {
      row.dataset.rmgPauseBound = 'true';
      row.addEventListener('mouseenter', function () {
        row.classList.add('is-paused');
      });
      row.addEventListener('mouseleave', function () {
        row.classList.remove('is-paused');
      });
      row.addEventListener('touchstart', function () {
        row.classList.add('is-paused');
      }, { passive: true });
      row.addEventListener('touchend', function () {
        row.classList.remove('is-paused');
      }, { passive: true });
    }
  }

  function initSection(root) {
    if (!root || root.dataset.rmgReady === 'true') return;
    root.dataset.rmgReady = 'true';

    var rows = root.querySelectorAll('[data-rmg-row]');
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (!reduceMotion) {
      // Wait a frame so images can start laying out card sizes
      window.requestAnimationFrame(function () {
        rows.forEach(setupRow);
      });

      var resizeTimer;
      window.addEventListener('resize', function () {
        window.clearTimeout(resizeTimer);
        resizeTimer = window.setTimeout(function () {
          rows.forEach(setupRow);
        }, 200);
      });
    }

    var lightbox = root.querySelector('[data-rmg-lightbox]');
    var lightboxMedia = root.querySelector('[data-rmg-lightbox-media]');
    var closeBtn = root.querySelector('[data-rmg-lightbox-close]');

    function closeLightbox() {
      if (!lightbox || !lightboxMedia) return;
      lightbox.classList.remove('is-open');
      lightbox.setAttribute('aria-hidden', 'true');
      lightboxMedia.innerHTML = '';
      document.documentElement.style.overflow = '';
    }

    function openLightbox(trigger) {
      if (!lightbox || !lightboxMedia || !trigger) return;
      var type = trigger.getAttribute('data-rmg-type');
      var src = trigger.getAttribute('data-rmg-src');
      var poster = trigger.getAttribute('data-rmg-poster') || '';
      if (!src) return;

      lightboxMedia.innerHTML = '';
      if (type === 'video') {
        var video = document.createElement('video');
        video.src = src;
        if (poster) video.poster = poster;
        video.controls = true;
        video.autoplay = true;
        video.playsInline = true;
        video.setAttribute('playsinline', '');
        lightboxMedia.appendChild(video);
      } else {
        var img = document.createElement('img');
        img.src = src;
        img.alt = trigger.getAttribute('data-rmg-alt') || '';
        lightboxMedia.appendChild(img);
      }

      lightbox.classList.add('is-open');
      lightbox.setAttribute('aria-hidden', 'false');
      document.documentElement.style.overflow = 'hidden';
    }

    root.addEventListener('click', function (event) {
      var trigger = event.target.closest('[data-rmg-open]');
      if (!trigger || !root.contains(trigger)) return;
      event.preventDefault();
      openLightbox(trigger);
    });

    if (closeBtn) closeBtn.addEventListener('click', closeLightbox);
    if (lightbox) {
      lightbox.addEventListener('click', function (event) {
        if (event.target === lightbox) closeLightbox();
      });
    }

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') closeLightbox();
    });
  }

  function initAll() {
    document.querySelectorAll('[data-review-media-gallery]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section =
      (event.target && event.target.querySelector && event.target.querySelector('[data-review-media-gallery]')) ||
      (event.target && event.target.hasAttribute && event.target.hasAttribute('data-review-media-gallery')
        ? event.target
        : null);
    if (section) {
      section.dataset.rmgReady = 'false';
      initSection(section);
    }
  });
})();
